import { gql, useLazyQuery, useQuery } from '@apollo/client';
import { TEXT_FIELDS } from "../../fragments";
export const GET_TEXT_BY_RELATED_AND_TEMPLATE_CODE = gql`
  ${TEXT_FIELDS}
  query getTextByRelatedAndTemplateCode($templateCode: String, $relatedObjectTypeId: Int, $relatedId: Long) {
    text_read_byRelatedAndTemplateCode(
      templateCode: $templateCode
      relatedObjectTypeId: $relatedObjectTypeId
      relatedId: $relatedId
    ) {
      ...TextFields
    }
  }
`;
export const GET_TEXT_BY_RELATED_AND_TEMPLATE_CODE_WITH_LOCALE = gql`
  ${TEXT_FIELDS}
  query getTextByRelatedAndTemplateCodeWithLocale($templateCode: String, $relatedObjectTypeId: Int, $relatedId: Long) {
    text_read_byRelatedAndTemplateCodeWithLocale(
      templateCode: $templateCode
      relatedObjectTypeId: $relatedObjectTypeId
      relatedId: $relatedId
    ) {
      ...TextFields
    }
  }
`;
export const useTextByRelatedAndTemplateCodeLazyQuery = options => {
  return useLazyQuery(GET_TEXT_BY_RELATED_AND_TEMPLATE_CODE, options);
};
export const useTextReadByRelatedAndTemplateCodeQuery = options => {
  return useQuery(GET_TEXT_BY_RELATED_AND_TEMPLATE_CODE, options);
};
export const useTextByRelatedAndTemplateCodeWithLocaleLazyQuery = options => {
  return useLazyQuery(GET_TEXT_BY_RELATED_AND_TEMPLATE_CODE_WITH_LOCALE, options);
};
export const useTextReadByRelatedAndTemplateCodeWithLocaleQuery = options => {
  return useQuery(GET_TEXT_BY_RELATED_AND_TEMPLATE_CODE_WITH_LOCALE, options);
};